import Button from "./Button";

export function ListPriceDealsButton({ onClick, disabled = false }) {
  return (
    <Button
      type="basic"
      label="New list price deal"
      size="small"
      disabled={disabled}
      loading={false}
      stretch={false}
      center={true}
      onClick={onClick}
    />
  );
}
